export default __webpack_public_path__ + "static/media/streamline-icon-search@23x23.aecce974.svg";